import { CheckableFieldComponent } from "./chunk-UIONNZDK.js";
import { Radio_default } from "./chunk-6Y4MXSCS.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioSwatch/RadioSwatch.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var RadioSwatch = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      description,
      image,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "description", "image", "className"]);
  return /* @__PURE__ */jsxs(CheckableFieldComponent, {
    id,
    name,
    label,
    description,
    className: clsx("pd:radio-swatch pd:radio-swatch--primary", className),
    children: [/* @__PURE__ */jsx(CheckableFieldComponent.Input, __spreadValues({
      ref,
      as: Radio_default,
      className: "pd:radio-swatch__input"
    }, rest)), /* @__PURE__ */jsxs(CheckableFieldComponent.Wrap, {
      className: "pd:radio-swatch__wrap",
      children: [/* @__PURE__ */jsx(CheckableFieldComponent.Image, {
        className: "pd:radio-swatch__img",
        children: /* @__PURE__ */jsx("div", {
          className: "pd:radio-swatch__img-inner",
          children: image
        })
      }), /* @__PURE__ */jsx(CheckableFieldComponent.Label, {
        className: "pd:radio-swatch__label"
      }), /* @__PURE__ */jsx(CheckableFieldComponent.Description, {
        className: "pd:radio-swatch__description"
      })]
    })]
  });
});
var RadioSwatch_default = RadioSwatch;
export { RadioSwatch_default };